document.querySelectorAll('.js-show-menu').forEach((button) => {
  button.addEventListener('click', function(event) {
    event.stopPropagation();
    event.preventDefault();
    document.body.classList.toggle('mopen');
  });
});

document.addEventListener('click', function(event) {
  const menu = document.querySelector('.menu');
  if (document.body.classList.contains('mopen') && !menu.contains(event.target)) {
    document.body.classList.remove('mopen');
  }
});

if (document.querySelector('.menu')) {
  document.querySelector('.menu').addEventListener('click', function(event) {
    event.stopPropagation();
  });
}


class MiniCart extends HTMLElement {
  constructor() {
    super();
    this.init();
    this.currencyLoaded = false;
  }

  init() {
    document.querySelector('.cart__show').addEventListener('click', (event) => {
      event.preventDefault();
      this.toggle();
    });

    document.querySelector('.cart').addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.close();
    });
    this.initElemens();
  }

  initElemens() {

    document.querySelector('.cart-block').addEventListener('click', (event) => {
      event.stopPropagation();
    });

    document.querySelectorAll('.js-close-cart').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        this.close();
      });
    });

    document.querySelectorAll('.cart-item__quantity-button').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const input = button.parentElement.querySelector('input');
        const quantity = parseInt(input.value);
        let max = 20;//parseInt(input.max) || 8;
        if (button.name === 'minus') {
          input.value = quantity - 1 <= 1 ? 1 : quantity - 1;
        } else {
          input.value = quantity + 1 >= max ? max : quantity + 1;
        }
        let newQuantity = parseInt(input.value);
        if (newQuantity !== quantity) {
          this.updateQuantity(button.dataset.index, input.value);
          button.classList.add('is-loading');
        }
      });
    });

    document.querySelectorAll('.cart-item__quantity-input').forEach((input) => {
      input.addEventListener('change', (event) => {
        event.preventDefault();
        const quantity = parseInt(input.value);
        let max = parseInt(input.max) || 8;
        if (quantity < 1) {
          input.value = 1;
        } else if (quantity > max) {
          input.value = max;
        }
        this.updateQuantity(input.dataset.index, input.value);
      });
      input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
        }
      });
    });

    document.querySelectorAll('.cart-item__delete').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        this.updateQuantity(button.dataset.index, 0);
        button.classList.add('is-loading');
      });
    });


    document.querySelectorAll('.js-quick-update-cart').forEach((form) => {
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const button = event.target.querySelector('button');
        button.classList.add('is-loading');
        let data = new FormData(form);
        addToCart(data, button);
      });
    });
  }

  close() {
    document.querySelector('body').classList.remove('cart-open');
  }
  open() {
    document.querySelector('body').classList.add('cart-open');
  }
  toggle() {
    document.querySelector('body').classList.toggle('cart-open');
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        section: 'template-cart-drawer',
        selector: '.cart-block',
      },
      {
        id: 'template-cart-count',
        section: 'template-cart-count',
        selector: '.cart__show-text',
      },
    ];
  }

  updateQuantity(line, quantity) {
    
    const body = JSON.stringify({
      line: line,
      quantity: parseInt(quantity),
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    document.querySelector('.cart-item[data-index="' + line + '"]').classList.add('is-loading');

    fetch(`${routes.cart_change_url}`, { 
      method: 'POST',
      headers: { 'Content-Type': 'application/json','Accept': 'application/json'},
      body,
     })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        if (parsedState.errors) {
          this.load().then(() => {
            this.handleErrors(parsedState.errors);
          });
          return;
        }
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace = document.querySelector(section.selector);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        this.initElemens();
      })
      .catch((e) => {
        this.handleErrors();
      })
      .finally(() => {
        let cartItem = document.querySelector('.cart-item[data-index="' + line + '"]');
        if (cartItem) {
          cartItem.classList.remove('is-loading');
        }
      });
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleErrors(error) {
    let e = document.createElement('div');
    if (!error) {
      error = 'An error occurred while updating the cart. Please try again.';
    } else if (typeof error === 'string') {
      if (error.indexOf('product-bulk') !== -1) {
        error = 'You can add up to 8 items to your cart. For bulk orders, please contact us at <a href="mailto:book@hungryminds.com">book@hungryminds.com</a>';
      }
    } else if (typeof error === 'object') {
      error = error.description;
    }
    
    e.innerHTML = `
      <div class="alert alert--hidden">
        <img src="https://cdn.shopify.com/s/files/1/0933/6717/3410/files/box.svg?v=1751529832" alt="box" class="alert__icon">
        <div class="alert__block">
          <span class="alert__text">
            ${error}
          </span>
        </div>
      </div>
    `;
    let wrapper = document.querySelector('.alert__wrapper');
    wrapper.insertBefore(e, wrapper.firstChild);

    setTimeout(() => {
      e.querySelector('.alert').classList.remove('alert--hidden');
    }, 100);
    setTimeout(() => {
      e.querySelector('.alert').classList.add('alert--hidden');
    }, 4900);
    setTimeout(() => {
      e.remove();
    }, 5000);
  }
  load() {
    const body = JSON.stringify({
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    return fetch(`${routes.cart_update_url}`, { 
      method: 'POST',
      headers: { 'Content-Type': 'application/json','Accept': 'application/json'},
      body,
    }).then((response) => {
      return response.json();
    }).then((state) => {

      //test if client currency is different from server currency
      if (!this.currencyLoaded && Shopify.currency && state.currency !== Shopify.currency.active) {
        return fetch('/services/currency/update?currency=' + Shopify.currency.active + '&country=' + Shopify.country)
          .then(() => {
            this.currencyLoaded = true;
            return this.load();
          })
          .then(() => {
            return Promise.reject('currency_reload');
          });
      } else {
        return new Promise((resolve) => {
          resolve(state);
        });
      }
    }).then((state) => {
      if (!state.sections) {
        return;
      }
      this.getSectionsToRender().forEach((section) => {
        const elementToReplace = document.querySelector(section.selector);
        elementToReplace.innerHTML = this.getSectionInnerHTML(
          state.sections[section.section],
          section.selector
        );
      });
      this.initElemens();
    }).catch((err) => {
      if (err === 'currency_reload') {
        return;
      }
      document.location.href = window.routes.cart_url;
      throw err;
    });
  }
}
customElements.define('mini-cart', MiniCart);


document.querySelectorAll('.js-product-form').forEach((form) => {

  function handleQuantityChange(event) {
    const value = parseInt(quantityInput.value);
    if (event.currentTarget.name === 'plus') {
      quantityInput.value = value + 1;
    } else if (event.currentTarget.name ==='minus' && value > 1) {
      quantityInput.value = value - 1;
    }
  }

  form.addEventListener('submit', (event) => {
    event.preventDefault();

    let data = new FormData(form);
    addToCart(data, button);
  });

  let button = form.querySelector('button[type="submit"]');
  let quantityInput = form.querySelector('.product-info__quantity-input');
  let quantityButtons = form.querySelectorAll('.product-info__quantity-button');
  
  quantityButtons.forEach((button) => {
    button.addEventListener('click', handleQuantityChange);
  });
});

function addToCart(data, button = null) {
  let dataObj = {
    method: 'POST',
    body: data,
  };

  let clsLoading = 'is-loading';
  if (button) {
    button.classList.add(clsLoading);
    button.disabled = true;
  }

  fetch(routes.cart_add_url + '.js', dataObj)
    .then((response) => response.json())
    .then((response) => {
      
      if (data.get('action_type') === 'replace') {
        dataObj.body.set('id', data.get('remove_line'));
        dataObj.body.set('quantity', 0);
        return fetch(routes.cart_change_url + '.js', dataObj)
          .then((response) => response.json())
      }
      return new Promise((resolve) => {
        resolve(response);
      });
    })
    .then((response) => {
      if (response.status) {
        if (button) {
          button.classList.remove(clsLoading);
          button.disabled = false;
        }
        document.querySelector('mini-cart').handleErrors(response.message);
        return;
      }

      const miniCart = document.querySelector('mini-cart');
      miniCart.load().then(() => {
        miniCart.open();
        if (button) {
          button.classList.remove(clsLoading);
          button.disabled = false;
        }
      });
      
    })
    .catch((error) => console.log(error));
}

let lastScrollTop = 0;
let scrollTimeoutId = null;
window.isMobile = window.innerWidth <= 768;
window.isTablet = window.innerWidth <= 1024;
window.isSmallLaptop = window.innerWidth <= 1280;

let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);
document.documentElement.style.setProperty('--ivh', `${vh}px`);

window.addEventListener('resize', () => {
  window.isMobile = window.innerWidth <= 768;
  window.isSmallLaptop = window.innerWidth <= 1280;
  window.isTablet = window.innerWidth <= 1024;

  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});
const isV3 = !!document.querySelector('.template-index');
const hasAnouncement = !!document.querySelector('.section--announcement-banner');
window.addEventListener('scroll', function() {
  let currentScrollTop = window.scrollY || document.documentElement.scrollTop;

  const stickyElm = document.querySelector('body');
  const header = stickyElm.querySelector('.header');
  let scrollOffset = 80;
  let onTopOffset = 0;
  if (isV3 && !hasAnouncement) {
    scrollOffset = window.innerHeight;
    onTopOffset = window.innerHeight;
  }
  

  clearTimeout(scrollTimeoutId);

  if (currentScrollTop > scrollOffset) {
    stickyElm.classList.add('is-pinned');
    if (Math.abs(currentScrollTop - lastScrollTop) < 10) {
      return;
    }
    if (currentScrollTop < lastScrollTop) {
      stickyElm.classList.add('is-fixed');
      if (currentScrollTop <= 200) {
        stickyElm.classList.remove('is-to-top');
      } else {
        stickyElm.classList.add('is-to-top');
      }
      header.style.transform = null;
    } else {
      header.style.transform = 'translateY(-200%)';
      stickyElm.classList.remove('is-to-top');
      scrollTimeoutId = setTimeout(() => {
        stickyElm.classList.remove('is-fixed');  
      }, 300);
    }
  } else if (currentScrollTop <= onTopOffset) {
    stickyElm.classList.remove('is-pinned');
    stickyElm.classList.remove('is-fixed');
    stickyElm.classList.remove('is-to-top');
    header.style.transform = null;
  }

  lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
});


(function videoReviews() {
  new Swiper('.js-video-reviews', {
    slidesPerView: 1.3,
    spaceBetween: 10,
    centeredSlides: true,
    loop: true,
    navigation: {
      prevEl: '.slider-product__arrow--left',
      nextEl: '.slider-product__arrow--right',
    },

    a11y: {
      scrollOnFocus: false,
    },
    pagination: {
      el: '.slider-product__circles',
      clickable: true,
      renderCustom: function (swiper, current, total) {
        let visibleDots = 7;
        let start = Math.max(current - Math.floor(visibleDots / 2), 1);
        let end = start + visibleDots - 1;

        if (end > total) {
          end = total;
          start = Math.max(end - visibleDots + 1, 1);
        }

        let dots = '';
        for (let i = start; i <= end; i++) {
          dots += `<button role="button" aria-label="Show slide ${i}" class="slider-product__circle ${i === current ? 'active' : ''}" data-index="${i - 1}"></span>`;
        }

        return dots;
      },
      type: 'custom'
    },
    on: {
      paginationRender(swiper) {
        document.querySelector('.slider-product__circle').addEventListener('click', function (e) {
          if (e.target.classList.contains('slider-product__circle')) {
            const index = parseInt(e.target.getAttribute('data-index'));
            swiper.slideTo(index);
          }
        });
      },
      slideChange(swiper) {
        swiper.pagination.render();
        swiper.pagination.update();
        swiper.hostEl.querySelectorAll('video').forEach((v) => {
          if (!v.paused && !v.ended && v.readyState > 2) {
            v.pause();
          }
        })
      },
    },
    breakpoints: {
      1200: {
        slidesPerView: 4,
        centeredSlides: false,
        loop: false,
      },
      992: {
        slidesPerView: 3,
        centeredSlides: false,
        loop: false,
      },
      768: {
        slidesPerView: 2,
      }
    }
  });

  document.querySelectorAll('.videos__item-play').forEach((v) => {
    v.addEventListener('click', (event) => {
      event.preventDefault();
      event.currentTarget.parentElement.classList.add('playing');
      let video = event.currentTarget.parentElement.querySelector('video');
      document.querySelectorAll('video').forEach((v) => {
        v.pause();
      });
      video.play();
      video.setAttribute('controls', true);
    })
  });

  document.querySelectorAll('.videos__item-play video').forEach((v) => {
    v.addEventListener('seeking', onSeekingVideo);
    v.addEventListener('pause', onPauseVideo);
    v.addEventListener('ended', onPauseVideo);
  });
  let isVideoSeeking = false;
  let videoPasueTimeout = null;
  function onSeekingVideo() {
    isVideoSeeking = true;
  }
  function onPauseVideo(event) {
    clearTimeout(videoPasueTimeout);
    let video = event.currentTarget;
    videoPasueTimeout = setTimeout(() => {
      if (isVideoSeeking) {
        isVideoSeeking = false;
        return;
      }
      if (video.readyState !== 4) {
        return;
      }
      video.parentElement.classList.remove('playing');
      video.removeAttribute('controls', null);
    }, 50);
  }
})();

document.querySelectorAll('.product-gallery').forEach((gallery) => {
  let thumbs = gallery.querySelector('.product-gallery__list');
  let galleryThumbs;
  if (thumbs) {
    galleryThumbs = new Swiper(thumbs, {
      direction: 'vertical',
      slidesPerView: 'auto',
      spaceBetween: 5,
    });
  }
  new Swiper(gallery.querySelector('.product-gallery__slider-wrap'), {
    thumbs: thumbs ? {
      swiper: galleryThumbs,
      slideThumbActiveClass: 'active',
    } : null,
    navigation: {
      nextEl: '.product-gallery__arrow--right',
      prevEl: '.product-gallery__arrow--left',
    },
    pagination: {
      el: '.product-gallery__lines',
      clickable: true,
      bulletClass: 'product-gallery__line',
      bulletActiveClass: 'active',
    },
  });
});

document.querySelectorAll('.js-accordion-title').forEach((title) => {
  title.addEventListener('click', (e) => {
    const content = e.currentTarget.nextElementSibling;
    const parent = e.currentTarget.parentElement;
    
    if (parent.classList.contains('active')) {
      content.style.maxHeight = 0;
    } else {
      content.style.maxHeight = content.scrollHeight + 'px';
      if (content.classList.contains('product-reviews__sub')) {
        setTimeout(() => {
          content.style.maxHeight = 'initial';
        }, 300);
      }
    }
    parent.classList.toggle('active');
    let event = new CustomEvent('accordion:toggle');
    document.dispatchEvent(event);
  });
});

document.querySelectorAll('.spotlight-wrapper').forEach((element) => {
  const illustrations = element.querySelectorAll('img, video');
  illustrations.forEach((i, index) => {
    i.addEventListener('click', () => {
      const images = [];
      illustrations.forEach((img) => {
        if (img.parentElement.tagName === 'VIDEO') {
          return;
        }
        images.push({
          src: img.dataset.fullSize || img.src,
        });
      });
      showSpotlight(images, index)
    });
  })
});

function showSpotlight(images, index) {
  Spotlight.show(images, {
    index: index + 1,
    autohide: false,
    control: 'close,next,prev,zoom',
    animation: isMobile ? 'slide' : 'slide,zoom',
  });
  if (isMobile && !window.disableMobileAutoZoom) {
    Spotlight.zoom(1.51);
  }
}

function isBelowViewport(el) {
  const rect = el.getBoundingClientRect();
  return rect.top + el.offsetHeight > window.innerHeight;
}

document.querySelectorAll('.video-product__unmute').forEach((videoButton) => {
  videoButton.addEventListener('click', (e) => {
    e.preventDefault();
    const video = videoButton.parentElement.querySelector('video');
    video.muted = false;
    e.currentTarget.style.display = 'none';
    video.setAttribute('controls', true);
  });
});


document.querySelectorAll('.video-product__play').forEach((videoButton) => {
  videoButton.addEventListener('click', (e) => {
    e.preventDefault();
    const video = videoButton.parentElement.querySelector('video');
    let btn = e.currentTarget;
    if (btn.dataset.fullVideo && btn.dataset.mobVideo) {
      video.style.width = video.videoWidth + 'px';
      video.style.height = video.videoHeight + 'px';
      let currentTime = video.currentTime;
      if (window.isMobile) {
        video.src = btn.dataset.mobVideo;
      } else {
        video.src = btn.dataset.fullVideo;
      }
      video.load();
      video.currentTime = currentTime;
      video.muted = false;
      video.loop = false;
    }
    if (!video.paused && !video.ended && video.readyState > 2) {
      video.pause();
      videoButton.parentElement.classList.remove('playing');
      video.removeAttribute('controls', null);
    } else {
      video.play();
      videoButton.parentElement.classList.add('playing');
      video.setAttribute('controls', true);
    }
  });
});

document.querySelectorAll('.illustration__title, .product .title').forEach((title) => {
  let text = title.textContent.toLowerCase();
  let letters = ['y', 'n', 't', 'p', 'r', 'd', 'b', 'h', 'u', 'j'];
  letters.forEach((letter) => {
    if (text.trim().indexOf(letter) === 0) {
      title.classList.remove('illustration__title--nomargin');
      title.classList.add('margin--letter-' + letter);
    }
  });
});

document.querySelectorAll('.js-input').forEach((input) => {
  input.addEventListener('change', (e) => {
    const input = e.target;
    if (!input.parentElement.querySelector('.form__label')) {
      return;
    }
    if (input.value) {
      input.parentElement.querySelector('.form__label').classList.add('form__label--active');
    } else {
      input.parentElement.querySelector('.form__label').classList.remove('form__label--active');
    }
  });
});

function formatMoney(amount, e) {
  if ("string" == typeof amount) {
    amount = amount.replace('.', '');
  }
  let i = '';
  const n = /\{\{\s*(\w+)\s*\}\}/,
    s = e || "${{amount}}";
  function o(t, e=2, i=",", n=".") {
      if (isNaN(t) || null == t)
          return 0;
      const s = (t = (t / 100).toFixed(e)).split(".");
      return s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${i}`) + (s[1] ? n + s[1] : "")
  }
  switch (s.match(n)[1]) {
    case "amount":
      i = o(amount, 2);
      break;
    case "amount_no_decimals":
      i = o(amount, 0);
      break;
    case "amount_with_comma_separator":
      i = o(amount, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      i = o(amount, 0, ".", ",")
  }
  return s.replace(n, i)
}

let dropdowns = document.querySelectorAll('.switch');
document.querySelectorAll('.switch').forEach((element) => {
  element.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    dropdowns.forEach(el => {
      if (el !== element) {
        el.classList.remove('active')
      };
    });
    element.classList.toggle('active');
    if (element.classList.contains('active')) {
      document.body.classList.add('switch-open');
      setTimeout(() => {
        let active = element.querySelector('.active');
        let dropdown = element.querySelector('.modal-choose__list');
        let wrapper = element.querySelector('.modal-choose');
        wrapper.innerHeight = dropdown.scrollHeight;
        if (!active) {
          return;
        }
        dropdown.scrollTo({
          top: active.offsetTop - dropdown.clientHeight / 2 - active.clientHeight / 2,
        });
      }, 10);
    }
  });

  element.querySelector('.modal-choose .form__input') && element.querySelector('.modal-choose .form__input').addEventListener('keyup', (e) => {
    let elements = window[element.dataset.variable];
    if (e.currentTarget.value) {
      let val = e.currentTarget.value.toLowerCase();
      elements = elements.filter((el) => {
        return el.name.toLowerCase().indexOf(val) !== -1;
      });
    }
    let html = '';
    elements.forEach((el) => {
      html += `<div class="modal-choose__item" data-code="${el.code}"><span class="modal-choose__item-text">${el.name}${el.currency ? (' - ' + el.currency) : ''}</span></div>`;
    });
    element.querySelector('.modal-choose__list').innerHTML = html;
    initDropdowns();
  });
});

document.querySelectorAll('.modal-choose').forEach((element) => {
  element.addEventListener('click', (e) => {
    e.stopPropagation();
  });
});

document.querySelectorAll('body, .menu').forEach((element) => {
  element.addEventListener('click', (e) => {
    dropdowns.forEach((el) => {
      if (el.classList.contains('active')) {
        document.body.classList.remove('switch-open');
        el.classList.remove('active');
        e.preventDefault();
      }
    });
  });
});

function initDropdowns() {
  document.querySelectorAll('.modal-choose__item').forEach((element) => {
    element.addEventListener('click', (e) => {
      e.stopPropagation();
      let code = element.dataset.code;
      let form = element.closest('.switch').querySelector('form');
      let input = form.querySelector('[data-input]');
      input.value = code;
      form.submit();
    });
  });
}
initDropdowns();



document.querySelectorAll('.product-info__lang-item:not(.product-info__lang-item--amount):not(.product-info__lang-item--date):not(.product-info__lang-item--option)').forEach((element) => {
  element.addEventListener('click', (e) => {
    e.currentTarget.classList.add('is-loading');
  });
});

document.querySelectorAll('.product-info__lang-item--option').forEach((element) => {
  element.addEventListener('click', (e) => {
    let el = e.currentTarget;
    el.parentElement.querySelectorAll('.product-info__lang-item--option').forEach((i) => {
      i.classList.remove('active');
    });
    el.classList.add('active');
    let form = el.closest('form');
    let variantId = el.querySelector('input').dataset.variantId;
    form.querySelector('[name=id]').value = variantId;
    const url = new URL(window.location);
    url.searchParams.set('variant', variantId);

    history.replaceState(null, "", url);
  });
});

if (window.localStorage && !localStorage.getItem('cart-currency')) {
  setTimeout(async function () {
    try {
      await fetch('/services/currency/update?currency=' + Shopify.currency.active + '&country=' + Shopify.country);
    } catch {}
  }, 5000);
  localStorage.setItem('cart-currency', '1')
}

document.querySelectorAll('.product-gallery__slider-bot').forEach((element) => {
  element.addEventListener('click', (e) => {
    document.querySelector('.product-gallery__slider .swiper-slide-active img').click();
  });
});

document.querySelectorAll('.product-info .product__stars').forEach((star) => {
  star.addEventListener('click', (e) => {
    const reviews = document.querySelector('.product-reviews__title');
    if (!reviews) {
      return;
    }
    smoothScroll(reviews, 1000);
  });
});

document.querySelectorAll('.js-scrollto').forEach((el) => {
  el.addEventListener('click', (e) => {
    e.preventDefault();
    const target = document.querySelector(el.dataset.target);
    if (!target) {
      return;
    }
    let offset = el.dataset.offset || 100;
    smoothScroll(target, el.dataset.speed || 1000, offset);
  });
});

function smoothScroll(target, duration, offset) {
  offset = offset || 100;
  const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - offset;
  const startPosition = window.pageYOffset;
  const distance = targetPosition - startPosition;
  let startTime = null;

  function animation(currentTime) {
    if (startTime === null) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    const run = ease(timeElapsed, startPosition, distance, duration);
    window.scrollTo(0, run);
    if (timeElapsed < duration) requestAnimationFrame(animation);
  }

  function ease(t, b, c, d) {
    t /= d / 2;
    if (t < 1) return c / 2 * t * t + b;
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
  }

  requestAnimationFrame(animation);
}

document.querySelectorAll('[data-modal]').forEach((element) => {
  element.addEventListener('click', (e) => {
    e.preventDefault();
    showModal(element.dataset.modal);
  });
});

document.querySelectorAll('.product-info__lang-item--table').forEach((element) => {
  element.addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelectorAll('table[data-table]').forEach((t) => {
      t.style.display = 'none';
    });
    document.querySelector(element.dataset.table).style.display = 'table';
  });
});


function showModal(query) {
  let modal = document.querySelector(query);
  if (!modal) {
    return;
  }
  modal.classList.add('active');
  document.body.classList.add('modal-open');
}

function closeModal() {
  document.body.classList.remove('modal-open');
  let modal = document.querySelector('.modal.active');
  if (modal) {
    modal.classList.remove('active');
    const event = new CustomEvent('modal:closed', {
      bubbles: true,
      detail: {
        modal,
      },
    });
    modal.dispatchEvent(event);
  }
}

document.querySelectorAll('.modal-block__close, .js-close-modal').forEach((element) => {
  element.addEventListener('click', (e) => {
    closeModal();
  });
});

document.querySelectorAll('.modal:not(.modal--strict)').forEach((element) => {
  element.addEventListener('click', (e) => {
    closeModal();
  });
});

document.querySelectorAll('.modal-block').forEach((element) => {
  element.addEventListener('click', (e) => {
    e.stopPropagation();
  });
});

document.addEventListener('keyup', (e) => {
  if (e.key === 'Escape') {
    closeModal();
  }
});

function initBackInstock() {
  let form = document.querySelector('.form--notify');
  if (!form) {
    return;
  }
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const modal = form.closest('.modal--notify');
    const errorBlock = modal ? modal.querySelector('[data-notify-error]') : form.querySelector('[data-notify-error]');
    const successBlock = modal ? modal.querySelector('[data-notify-success]') : form.querySelector('[data-notify-success]');
    if (errorBlock) errorBlock.style.display = 'none';
    if (successBlock) successBlock.style.display = 'none';

    const endpoint = form.getAttribute('action');
    if (!endpoint) {
      if (errorBlock) {
        errorBlock.style.display = 'block';
      };
      return;
    }

    const button = form.querySelector('button[type="submit"]');
    if (button) {
      button.disabled = true;
      button.classList.add('is-loading');
    }
    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        body: new FormData(form)
      });
      let isSuccess = response.ok;
      try {
        const json = await response.json();
        if (typeof json.success !== 'undefined') {
          isSuccess = Boolean(json.success);
        }
      } catch {}

      if (isSuccess) {
        form.reset();
        if (successBlock) {
          successBlock.style.display = 'block';
          modal.querySelectorAll('.modal-block__text').forEach((group) => {
            group.style.display = 'none';
          });
        }
        form.style.display = 'none';
      } else if (errorBlock) {
        errorBlock.style.display = 'block';
      }
    } catch {
      if (errorBlock) {
        errorBlock.style.display = 'block'
      };
    } finally {
      if (button) {
        button.disabled = false;
        button.classList.remove('is-loading');
      }
    }
  });
}

if (document.querySelector('.form--notify')) {
  initBackInstock();
}

document.querySelectorAll('.js-contact-form').forEach((form) => {
  const modal = form.closest('.modal');
  const errorBlock = form.querySelector('.error');
  const successBlock = modal ? modal.querySelector('.success') : form.parentElement.querySelector('.success');

  const resetModalState = () => {
    form.reset();
    form.style.display = '';
    if (errorBlock) {
      errorBlock.style.display = 'none';
    }
    if (successBlock) {
      successBlock.style.display = 'none';
    }
  };

  if (modal) {
    modal.addEventListener('modal:closed', () => {
      resetModalState();
    });
  }

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const formData = new FormData(form);
    const button = form.querySelector('button[type="submit"]') || form.querySelector('button');
    if (errorBlock) {
      errorBlock.style.display = 'none';
    }
    if (button) {
      button.disabled = true;
      button.classList.add('is-loading');
    }
    try {
      const response = await fetch(form.getAttribute('action'), {
        method: 'POST',
        body: formData
      });
      const json = await response.json();
      if (json.success) {
        form.reset();
        if (successBlock) {
          successBlock.style.display = 'block';
        }
        form.style.display = 'none';
      } else if (errorBlock) {
        errorBlock.style.display = 'block';
      }
    } catch {
      if (errorBlock) {
        errorBlock.style.display = 'block';
      }
    } finally {
      if (button) {
        button.disabled = false;
        button.classList.remove('is-loading');
      }
    }
  });
});

document.querySelectorAll('.js-footer-form').forEach((form) => {
  const button = form.querySelector('button[type="submit"]');
  const errorBlock = form.querySelector('[data-footer-form-error]');
  const formContainer = form.closest('.footer-block__subscribe') || form.parentElement;
  const successBlock = formContainer ? formContainer.querySelector('[data-footer-form-success]') : null;
  const defaultErrorHTML = errorBlock ? errorBlock.innerHTML : '';

  const toggleMessage = (element, show) => {
    if (!element) {
      return;
    }
    element.hidden = !show;
  };

  const showError = (message) => {
    if (!errorBlock) {
      return;
    }
    errorBlock.innerHTML = defaultErrorHTML;
    if (message) {
      errorBlock.textContent = message;
    }
    toggleMessage(errorBlock, true);
  };

  const getErrorMessage = () => {
    return '';
  };

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    if (form.dataset.loading === 'true') {
      return;
    }

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const endpoint = form.getAttribute('action');
    if (!endpoint) {
      showError();
      return;
    }

    form.dataset.loading = 'true';
    toggleMessage(errorBlock, false);
    toggleMessage(successBlock, false);

    if (errorBlock) {
      errorBlock.innerHTML = defaultErrorHTML;
    }
    if (button) {
      button.disabled = true;
      button.classList.add('is-loading');
    }

    try {
      const response = await fetch(endpoint, {
        method: form.getAttribute('method') || 'POST',
        body: new FormData(form),
        headers: {
          Accept: 'application/json',
        },
      });
      let payload = null;
      try {
        payload = await response.json();
      } catch {}

      const isSuccess = response.ok && (!payload || payload.success !== false);

      if (isSuccess) {
        form.reset();
        form.hidden = true;
        toggleMessage(successBlock, true);
      } else {
        showError(getErrorMessage(payload));
      }
    } catch {
      showError();
    } finally {
      delete form.dataset.loading;
      if (button) {
        button.disabled = false;
        button.classList.remove('is-loading');
      }
    }
  });
});

let klaviyoFormsEvents = {};
window.addEventListener('klaviyoForms', function (e) {
  const detail = e.detail || {};
  let type = detail.type;
  let formId = detail.formId;
  let allowedFormIds = ['Y5p4Ux', 'SEER5k', 'UGgrRP', 'YgTaTN'];
  if (allowedFormIds.indexOf(formId) === -1) {
    return;
  }
  if (klaviyoFormsEvents[type]) {
    return;
  }
  klaviyoFormsEvents[type] = true;
  window.igEvents = window.igEvents || [];
  if (type === 'open') {
    window.igEvents.push({'event': '5forfree-popped'});
  } else  if (type === 'submit') {
    window.igEvents.push({'event': '5forfree-submitted'});
  }
});

document.querySelectorAll('.blog-list__tabs a').forEach((link) => {
  link.addEventListener('click', (e) => {
    let blogItems = document.querySelector('.blog-list__items');
    e.preventDefault();
    document.querySelectorAll('.blog-list__tab--active').forEach((link) => {
      link.classList.remove('blog-list__tab--active');
    });
    e.target.classList.add('blog-list__tab--active');
    blogItems.classList.add('loading');

    if (document.querySelector('.blog-list__tabs-list')) {
      document.querySelector('.blog-list__tabs-list').classList.remove('blog-list__tabs-list--active');
      document.querySelector('.blog-list__tabs-current span').textContent = e.target.textContent;
    }
    fetch(`${link.href}?section_id=blog`)
      .then((response) => response.text())
      .then((html) => {
        let div = document.createElement('div');
        div.innerHTML = html;
        blogItems.innerHTML = div.querySelector('.blog-list__items').innerHTML;
        history.replaceState({}, '', link.href);
      }).finally((error) => {
        blogItems.classList.remove('loading');
      });
  });
});

if (document.querySelector('.blog-list__tabs-current')) {
  document.querySelector('.blog-list__tabs-current').addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelector('.blog-list__tabs-list').classList.toggle('blog-list__tabs-list--active');
    document.querySelector('.blog-list__tabs-current').classList.toggle('blog-list__tabs-current--active');
  });
}


document.querySelectorAll('.video-product__video--hide').forEach((video) => {
  video.addEventListener('click', (e) => {
    if (e.currentTarget.parentElement.classList.contains('playing')) {
      e.preventDefault();
      video.removeAttribute('autoplay', null);
      video.pause();
      video.currentTime = video.currentTime;

      video.parentElement.classList.remove('playing');
      video.removeAttribute('controls', null);
    }
  });
});
